// client/src/components/documentos/CertificadosHistoricoPage.js
import React, { Fragment, useState } from 'react';
import { Award, Eye, Loader2, X } from 'lucide-react';
import PageHeader from '../layout/PageHeader';
import { useCertificadosHistorico, useCertificadoHistoricoById } from '../../hooks/useCertificadosHistorico';

const fmtData = (data) => (data ? new Date(data).toLocaleString('pt-BR') : '—');

const getClienteNome = (cliente) => {
    if (!cliente || typeof cliente !== 'object') return '—';
    return cliente.user?.name || '—';
};

const getCursoNome = (curso) => {
    if (!curso) return '—';
    if (typeof curso === 'object') return curso.nome || '—';
    return '—';
};

const CertificadoPreviewModal = ({ certificadoId, onClose }) => {
    const { data: certificado, isLoading } = useCertificadoHistoricoById(certificadoId);

    return (
        <div
            style={{
                position: 'fixed', inset: 0, zIndex: 1000,
                background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '1rem',
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: '#fff', borderRadius: 12, padding: '1.5rem', maxWidth: 820, width: '100%',
                    maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <h3 className="form-title" style={{ margin: 0 }}>
                        {certificado?.templateNome || 'Certificado'}
                    </h3>
                    <button onClick={onClose} className="form-close-button" title="Fechar">
                        <X size={20} />
                    </button>
                </div>

                {isLoading ? (
                    <div className="table-loading-state">
                        <Loader2 size={24} className="animate-spin" />
                        <span>Carregando certificado...</span>
                    </div>
                ) : certificado ? (
                    <div
                        style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: '1rem', background: '#fff' }}
                        dangerouslySetInnerHTML={{ __html: certificado.htmlGerado || '<p>Certificado sem conteúdo gerado.</p>' }}
                    />
                ) : (
                    <p className="text-muted">Certificado não encontrado.</p>
                )}
            </div>
        </div>
    );
};

const CertificadosHistoricoPage = () => {
    const { data: certificados = [], isLoading } = useCertificadosHistorico();
    const [previewId, setPreviewId] = useState(null);

    return (
        <Fragment>
            {previewId && <CertificadoPreviewModal certificadoId={previewId} onClose={() => setPreviewId(null)} />}

            <div className="page-management-container">
                <PageHeader
                    icon={<Award />}
                    title="Histórico de Certificados"
                    subtitle={!isLoading ? `${certificados.length} certificado${certificados.length !== 1 ? 's' : ''}` : null}
                />
            </div>

            <div className="table-container">
                <div className="table-wrapper">
                    {isLoading ? (
                        <div className="table-loading-state">
                            <Loader2 size={24} className="animate-spin" />
                            <span>Carregando certificados...</span>
                        </div>
                    ) : certificados.length > 0 ? (
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>Cliente</th>
                                    <th>Curso</th>
                                    <th>Template</th>
                                    <th>Emitido em</th>
                                    <th className="text-right">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {certificados.map((certificado) => (
                                    <tr key={certificado._id}>
                                        <td style={{ textAlign: 'left' }}>{getClienteNome(certificado.cliente)}</td>
                                        <td>{getCursoNome(certificado.curso)}</td>
                                        <td>{certificado.templateNome || '—'}</td>
                                        <td style={{ fontSize: '0.8rem', color: '#475569', whiteSpace: 'nowrap' }}>
                                            {fmtData(certificado.createdAt)}
                                        </td>
                                        <td className="text-right">
                                            <button
                                                onClick={() => setPreviewId(certificado._id)}
                                                className="action-button-icon text-blue-600"
                                                title="Visualizar certificado"
                                            >
                                                <Eye size={18} className="icon" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="table-empty-state">
                            <Award size={48} />
                            <h3>Nenhum certificado emitido</h3>
                            <p>Certificados gerados a partir de uma matrícula aparecerão aqui.</p>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default CertificadosHistoricoPage;
